import { useState } from "react";

export const useSettingsTabs = () => {
  const [activeTab, setActiveTab] = useState("company");
  return { activeTab, setActiveTab };
};
